var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIconBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82031 12C4.82031 7.58172 8.40203 4 12.8203 4C17.2386 4 20.8203 7.58172 20.8203 12C20.8203 16.4183 17.2386 20 12.8203 20C8.40203 20 4.82031 16.4183 4.82031 12ZM12.8203 2C7.29747 2 2.82031 6.47715 2.82031 12C2.82031 17.5228 7.29747 22 12.8203 22C18.3432 22 22.8203 17.5228 22.8203 12C22.8203 6.47715 18.3432 2 12.8203 2ZM12.8203 17.5004C12.268 17.5004 11.8203 17.0527 11.8203 16.5004V10.5323C11.8203 9.98002 12.268 9.53231 12.8203 9.53231C13.3726 9.53231 13.8203 9.98002 13.8203 10.5323V16.5004C13.8203 17.0527 13.3726 17.5004 12.8203 17.5004ZM11.8203 7.49906C11.8203 6.94713 12.268 6.49971 12.8203 6.49971C13.3726 6.49971 13.8203 6.94713 13.8203 7.49906C13.8203 8.05098 13.3726 8.4984 12.8203 8.4984C12.268 8.4984 11.8203 8.05098 11.8203 7.49906Z",
    fill: "#3F4451"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconBlack);
export default __webpack_public_path__ + "static/media/info-icon-black.913e1e94fac7c4f31d024e8aec02f6c4.svg";
export { ForwardRef as ReactComponent };